"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var utils_1 = require("./../utils");

var utils_2 = require("./../utils");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");
/**
 * A wrapper component that allows to use observables for prop values of a
 * given component.
 */


var LiftWrapper =
/** @class */
function (_super) {
  __extends(LiftWrapper, _super);

  function LiftWrapper(props) {
    return _super.call(this, props, LiftWrapper._initState) || this;
  }

  LiftWrapper.prototype.render = function () {
    return this.state.renderCache || null;
  };

  LiftWrapper.prototype._subscribe = function (newProps) {
    var props = newProps.props,
        component = newProps.component;
    var n = 0;
    walkObservables(props, function () {
      return n += 1;
    });

    switch (n) {
      case 0:
        this.setState({
          subscription: null,
          renderCache: render(component, props)
        });
        break;
      // @NOTE original Calmm code below
      // The created object is never used and it looks like that
      // the useful work is done in the constructor.
      // Could this be replaced by a regular closure? Perhaps using
      // a class is an optimization?

      case 1:
        new RenderOne(this, newProps); // tslint:disable-line

        break;

      default:
        new RenderMany(this, newProps, n); // tslint:disable-line

        break;
    }
  };

  LiftWrapper.prototype._unsubscribe = function () {
    var subscription = this.state ? this.state.subscription : null;
    if (subscription) subscription.unsubscribe();
  };

  LiftWrapper.prototype.componentWillReceiveProps = function (newProps) {
    this._unsubscribe();

    this._subscribe(newProps);
  };

  LiftWrapper.prototype.componentWillMount = function () {
    this._unsubscribe();

    this._subscribe(this.props);
  };

  LiftWrapper.prototype.componentWillUnmount = function () {
    this._unsubscribe();

    this.setState(LiftWrapper._initState);
  };

  LiftWrapper.prototype.shouldComponentUpdate = function (_newProps, newState, _newContext) {
    return newState.renderCache !== this.state.renderCache;
  };

  LiftWrapper._initState = {
    renderCache: null,
    subscription: null
  };
  LiftWrapper._endState = {
    subscription: null
  };
  return LiftWrapper;
}(React.Component);

exports.LiftWrapper = LiftWrapper;
/**
 * 'Lift' a component so it can accept observable values for props.
 *
 * A lifted component will accept a value of Observable<T> for any prop of
 * type T. However, this is not registered in the lifted component prop types
 * in any way (not possible right now), so casting observable values to `any` is
 * required.
 *
 *
 * @example
 * import { lift } from '@grammarly/focal';
 *
 * type HelloComponentProps = { name: string };
 *
 * const HelloComponent = ({ name }: HelloComponentProps) => <div>Hello, {name}.</div>;
 *
 * // normal usage
 * <HelloComponent name='world' />
 *
 * // lifted version of the same component
 * const LiftedHelloComponent = lift(HelloComponent);
 *
 * const observableValue = Observable.of('world'));
 *
 * // using an observable value for prop
 * <LiftedHelloComponent name={observableValue as any} />
 */

function lift(component) {
  return function (props) {
    return React.createElement(LiftWrapper, {
      component: component,
      props: props
    });
  };
}

exports.lift = lift;
var PROP_CHILDREN = 'children';
var PROP_STYLE = 'style';
exports.PROP_MOUNT = 'mount';
exports.PROP_REF = 'ref';
/**
 * Walk a React component props object tree, and for each observable prop found,
 * call the supplied action. 'children' and 'style' props are specially treated.
 *
 * @param props React component props
 * @param action action to run for each observable prop
 */

function walkObservables(props, action) {
  for (var key in props) {
    var value = props[key]; // any observable component property

    if (value instanceof rxjs_1.Observable) {
      action(value); // 'children' is an array
    } else if (PROP_CHILDREN === key && value instanceof Array) {
      var n = value.length;

      for (var i = 0; i < n; ++i) {
        var child = value[i];
        if (child instanceof rxjs_1.Observable) action(child);
      } // 'style' prop

    } else if (PROP_STYLE === key) {
      for (var k in value) {
        var style = value[k];
        if (style instanceof rxjs_1.Observable) action(style);
      }
    }
  }
}
/**
 * Render a React component with given props and observable prop values.
 *
 * @param class_ React component class
 * @param props component props
 * @param values observable props values, ordered by appearance in flattened tree
 * @returns rendered element
 */


function render(class_, props, observedValues) {
  if (observedValues === void 0) {
    observedValues = [];
  } // @TODO can we do a better type here?


  var newProps = {};
  var newChildren;
  var k = -1; // Here we will do exactly the same walk as we did in `walkObservables` when filling
  // out the `values` argument before this function is called. We will also use the value
  // of prop named 'mount' as a value for the 'ref' prop (it is special in React).
  //
  // It is ugly and hacky, but supposedly a space optimization from the original Calmm
  // implementation.

  for (var key in props) {
    var propValue = props[key];
    var isChildren = key === PROP_CHILDREN;
    var isMount = key === exports.PROP_MOUNT;
    var isStyle = key === PROP_STYLE; // prop is an observable

    if (propValue instanceof rxjs_1.Observable) {
      var observedValue = observedValues[++k];

      if (isChildren) {
        newChildren = observedValue;
      } else if (isMount) {
        newProps.ref = observedValue;
      } else {
        newProps[key] = observedValue;
      } // 'children' prop

    } else if (isChildren) {
      if (propValue instanceof Array) {
        var n = propValue.length;

        for (var i = 0; i < n; ++i) {
          var child = propValue[i];

          if (child instanceof rxjs_1.Observable) {
            if (!newChildren) {
              newChildren = Array(propValue.length);

              for (var j = 0; j < i; ++j) {
                newChildren[j] = propValue[j];
              }
            }

            newChildren[i] = observedValues[++k];
          } else if (newChildren) {
            newChildren[i] = propValue[i];
          }
        }
      }

      newChildren = newChildren || propValue; // 'mount' prop
    } else if (isMount) {
      newProps.ref = propValue; // 'style' prop
    } else if (isStyle) {
      var newStyle = void 0;

      for (var i in propValue) {
        var style = propValue[i];

        if (style instanceof rxjs_1.Observable) {
          if (!newStyle) {
            newStyle = {};

            for (var j in propValue) {
              if (j === i) break;
              newStyle[j] = propValue[j];
            }
          }

          newStyle[i] = observedValues[++k];
        } else if (newStyle) {
          newStyle[i] = style;
        }
      }

      newProps.style = newStyle || propValue; // all other (non-liftable) props
    } else {
      newProps[key] = propValue;
    }
  }

  return React.createElement(class_, newProps, newChildren === undefined ? null : newChildren);
}
/**
 * A dummy React component mock that is used to preserve any state changes
 * pushed onto the component.
 */


var FakeComponent =
/** @class */
function () {
  function FakeComponent(state, props) {
    this.state = state;
    this.props = props;
  }

  FakeComponent.prototype.setState = function (newState) {
    if ('subscription' in newState) this.state.subscription = newState.subscription;
    if ('renderCache' in newState) this.state.renderCache = newState.renderCache;
  };

  return FakeComponent;
}(); // could make sense to make this configurable


var handleError = function handleError(e) {
  throw e;
};

function warnEmptyObservable(componentName) {
  utils_2.warning((componentName ? "The component <" + componentName + ">" : 'An unnamed component') + " has " + "received an observable that doesn't immediately emit a value in one of its props. " + "Since this observable hasn't yet called its subscription handler, the component " + "can not be rendered at the time. " + ("Check the props of " + (componentName ? "<" + componentName + ">" : 'this component') + "."));
}
/**
 * A rendering helper class specialized for the single observable prop case.
 *
 * @template P component props
 */


var RenderOne =
/** @class */
function () {
  function RenderOne(liftedComponent, newProps) {
    var _this = this;

    this._receivedValue = false;
    var state = {
      subscription: this,
      renderCache: liftedComponent.state && liftedComponent.state.renderCache
    };
    this._liftedComponent = new FakeComponent(state, newProps);
    walkObservables(newProps.props, function (observable) {
      _this._innerSubscription = observable.subscribe(function (v) {
        return _this._handleValue(v);
      }, handleError, function () {
        return _this._handleCompleted();
      }); // observable has completed and unsubscribed by itself

      if (_this._innerSubscription && _this._innerSubscription.closed) _this._innerSubscription = null;
    });
    if (utils_2.DEV_ENV && !this._receivedValue) warnEmptyObservable(utils_2.getReactComponentName(this._liftedComponent.props.component));
    this._liftedComponent = liftedComponent;
    liftedComponent.setState(state);
  }

  RenderOne.prototype.unsubscribe = function () {
    if (this._innerSubscription) this._innerSubscription.unsubscribe();
  };

  RenderOne.prototype._handleValue = function (value) {
    // only required for empty observable check
    if (utils_2.DEV_ENV) this._receivedValue = true;
    var liftedComponent = this._liftedComponent;
    var _a = liftedComponent.props,
        component = _a.component,
        props = _a.props;
    var renderCache = render(component, props, [value]);
    if (!utils_1.structEq(liftedComponent.state.renderCache, renderCache)) liftedComponent.setState({
      renderCache: renderCache
    });
  };

  RenderOne.prototype._handleCompleted = function () {
    this._innerSubscription = null;

    this._liftedComponent.setState(LiftWrapper._endState);
  };

  return RenderOne;
}();
/**
 * A rendering helper class specialized for the many observable prop case.
 *
 * @template P component props
 */


var RenderMany =
/** @class */
function () {
  function RenderMany(liftedComponent, newProps, N) {
    var _this = this;

    var state = {
      subscription: this,
      renderCache: liftedComponent.state && liftedComponent.state.renderCache
    };
    this._liftedComponent = new FakeComponent(state, newProps);
    this._innerSubscriptions = [];
    this._values = Array(N);

    for (var i = 0; i < N; ++i) {
      this._values[i] = this;
    }

    walkObservables(newProps.props, function (observable) {
      var i = _this._innerSubscriptions.length;
      var subscription = observable.subscribe(function (v) {
        return _this._handleValue(i, v);
      }, handleError, function () {
        return _this._handleCompleted(i);
      }); // observable has completed and unsubscribed by itself

      if (subscription && subscription.closed) subscription = null; // handlers are called at subscribe time
      // before unsubscriber was added to this.innerSubscriptions

      _this._innerSubscriptions.push(subscription);
    }); // At this point all handlers should have been called.
    // If that's not the case, then there's an empty observable in one of the
    // props.
    //
    // Since the component can't be rendered until every handler is called at
    // least once, and a handler of an empty observable will never be called,
    // this component will never get rendered.

    if (utils_2.DEV_ENV) for (var i = this._values.length - 1; 0 <= i; --i) {
      if (this._values[i] === this) {
        warnEmptyObservable(utils_2.getReactComponentName(liftedComponent.props.component));
        break;
      }
    }
    this._liftedComponent = liftedComponent;
    liftedComponent.setState(state);
  }

  RenderMany.prototype.unsubscribe = function () {
    var _this = this;

    var i = -1;
    walkObservables(this._liftedComponent.props.props, function (_) {
      var unsubscriber = _this._innerSubscriptions[++i];
      if (unsubscriber) unsubscriber.unsubscribe();
    });
  };

  RenderMany.prototype._handleValue = function (idx, value) {
    this._values[idx] = value; // do nothing if at least one of the observables hasn't
    // sent a value yet

    for (var i = this._values.length - 1; 0 <= i; --i) {
      if (this._values[i] === this) return;
    }

    var liftedComponent = this._liftedComponent;
    var _a = liftedComponent.props,
        component = _a.component,
        props = _a.props;
    var renderCache = render(component, props, this._values);
    if (!utils_1.structEq(liftedComponent.state.renderCache, renderCache)) liftedComponent.setState({
      renderCache: renderCache
    });
  };

  RenderMany.prototype._handleCompleted = function (idx) {
    var n = this._innerSubscriptions.length;
    if (n > idx) this._innerSubscriptions[idx] = null;
    if (n !== this._values.length) return;

    for (var i = 0; i < n; ++i) {
      if (this._innerSubscriptions[i]) return;
    }

    this._liftedComponent.setState(LiftWrapper._endState);
  };

  return RenderMany;
}();
/**
 * Filter out undefined, null, false and empty strings.
 * Throw on a `true` value.
 */


function filterClassNames(cs) {
  return cs.filter(function (c) {
    if (c === true) throw new TypeError('Unexpected `true` value in classes');
    return c !== null && c !== undefined && c !== '' && c !== false;
  });
}
/**
 * Declare element's classes through an array of observables.
 *
 * Each observable defines the presence of a single respective CSS
 * class in the resulting element's class attribute. If this observable's
 * most recent value is a null or undefined, it will not be included in
 * the resulting class attribute value.
 *
 * You can also use this with regular components, but if you have *at least one*
 * observable in the class name list, you will *need* to use a
 * [lifted component]{@link LiftedComponent} only.
 *
 * @example
 * import { Atom, classes } from '@grammarly/focal';
 *
 * const a = Atom.create(null as string);
 * const b = Atom.create(null as string);
 * const c = Atom.create(null as string);
 *
 * const className = classes(a, b, c).className;
 * const sub = className.subscribe(x => console.log(x));
 *
 * // prints ''
 *
 * a.set('one');
 * // prints 'one'
 *
 * b.set('two');
 * // prints 'one two'
 *
 * c.set('three')
 * // prints 'one two three'
 *
 * b.set(null as string);
 * // prints 'one three'
 *
 * a.set(null as string);
 * // prints 'three'
 *
 * sub.unsubscribe();
 * @example
 * import { Atom, classes } from '@grammarly/focal';
 *
 * const c = Atom.create('c');
 *
 * <F.div {...classes(2 > 3 && 'a', 'b', c)}>Hello.</F.div>
 * @returns an object to be spread in a JSX element properties
 */


function classes() {
  var cs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    cs[_i] = arguments[_i];
  } // case w/o observables


  if (!cs || cs.find(function (x) {
    return x instanceof rxjs_1.Observable;
  }) === undefined) {
    var filtered = filterClassNames(cs || [] // assert ClassNameLike[]: no observables (checked above)
    ); // assert string[]: no observables (checked above)

    return {
      className: filtered.length > 0 ? filtered.join(' ') : undefined
    }; // case with observables
  } else {
    return {
      className: rxjs_1.combineLatest(filterClassNames(cs || []).map(function (x) {
        // @TODO optimize: unnecessary Observable.of
        // can we actually already just remove this?
        return !(x instanceof rxjs_1.Observable) ? rxjs_1.of(x) : x;
      }), function () {
        var cs = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          cs[_i] = arguments[_i];
        }

        var filtered = filterClassNames(cs || []);
        return filtered.length > 0 ? filtered.join(' ') : undefined;
      })
    };
  }
}

exports.classes = classes; // @TODO this is naїve, can we do better?

function combineTemplate(template) {
  var keys = [];
  var values = [];

  for (var k in template) {
    keys.push(k);
    values.push(template[k]);
  }

  return rxjs_1.combineLatest(values, function () {
    var vs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      vs[_i] = arguments[_i];
    }

    var r = {};

    for (var i = 0; i < keys.length; i++) {
      r[keys[i]] = vs[i];
    }

    return r;
  });
}
/**
 * Creates a callback to be used with a React [ref]{@link React.ClassAttributes#ref}
 * prop to propagate any values in given observable dictionary to
 * respective instance element properties.
 */


function setElementProps(template) {
  var observable = null;
  var subscription = null;
  return function (domElement) {
    if (subscription) {
      subscription.unsubscribe();
      subscription = null;
      observable = null;
    }

    if (domElement) {
      observable = combineTemplate(template);
      subscription = observable.subscribe(function (value) {
        for (var k in value) {
          domElement[k] = value[k];
        }
      }, handleError, function () {
        observable = null;
        subscription = null;
      });
    }
  };
}

exports.setElementProps = setElementProps;
/**
 * Creates a React event handler that will set the given dictionary of
 * atoms to their respective component property values.
 */

function getElementProps(template) {
  return function (e) {
    for (var k in template) {
      template[k].set(e.target[k]);
    }
  };
}

exports.getElementProps = getElementProps;

function bindElementProps( // @TODO need to fix the type of { [k: string]: string | Atom<any> }.
// this function already compiles without the 'string | ...', but it's
// calls do not.
template) {
  var _a, _b;

  var _c = exports.PROP_REF,
      ref = template[_c],
      _d = exports.PROP_MOUNT,
      mount = template[_d],
      tpl = __rest(template, [typeof _c === "symbol" ? _c : _c + "", typeof _d === "symbol" ? _d : _d + ""]);

  return ref ? (_a = {}, _a[exports.PROP_REF] = setElementProps(tpl), _a[ref] = getElementProps(tpl), _a) : mount ? (_b = {}, _b[exports.PROP_MOUNT] = setElementProps(tpl), _b[mount] = getElementProps(tpl), _b) : {};
}

exports.bindElementProps = bindElementProps;
/**
 * Two-way bind component props to respective atoms. Any changes in the
 * atom will then trigger component update, and any change in the component's
 * prop value will be pushed onto the atom.
 *
 * The component is _required_ to be a {@link LiftedComponent}.
 *
 * Your component needs to be lifted.
 *
 * @example
 * import { Atom, F, bind } from '@grammarly/focal';
 *
 * const checked = Atom.create(false);
 *
 * <F.input type='checkbox'
 *          {...bind({ checked })}/>
 * @returns a props object with an `onChange` handler that will handle the two-way binding
 */

function bind(template) {
  return __assign({}, template, {
    onChange: getElementProps(template)
  });
}

exports.bind = bind; // tslint:enable no-unused-vars

/**
 * Derive a reactive list from:
 * - an observable of list item ids
 * - a list item factory – a function that will create a list item based on item id.
 */

function reactiveList(ids, createListItem) {
  return ids.pipe(operators_1.scan(function (_a, ids) {
    var oldIds = _a[0],
        _ = _a[1];
    var newIds = {};
    var newValues = Array(ids.length);
    var n = ids.length;

    for (var i = 0; i < n; ++i) {
      var id = ids[i];
      var k = id.toString();

      if (k in newIds) {
        newValues[i] = newIds[k];
      } else {
        newIds[k] = newValues[i] = k in oldIds ? oldIds[k] : createListItem(id);
      }
    }

    return [newIds, newValues];
  }, [{}, []]), operators_1.map(function (_a) {
    var values = _a[1];
    return values;
  }));
}

exports.reactiveList = reactiveList;